export default class SelectionWithParamDto {
    constructor(obj) {
        this.code = obj.code // String
        this.name = obj.name // String
        this.listType = obj.listType // Double
        this.parentCode = obj.parentCode // Option[String]
        this.default = obj.default // Option[String]
        this.parameters = obj.parameters // Seq[String]
    }
}